<template>
  <v-card class="review-confirm">
    <v-subheader>
      <v-icon medium color="success" class="mr-2">people</v-icon>
      {{date}} <span class="ml-2">Подтверждено участие в ревью уровня {{level}}</span>
    </v-subheader>
  </v-card>
</template>

<script>
  export default {
    name: "ReviewConfirm",
    props: ["date", "description", "level"]
  }
</script>

<style scoped>
  .review-confirm {
    border: 1px solid #78909C;
  }

</style>